import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { ExpandMore as ExpandMoreBase } from '@mui/icons-material'

export const Root = styled('div')`
  background: ${props => props.theme.palette.brand.gray3};
  width: 100%;
`

export const Anchor = styled('div')`
  border-bottom: 1px solid ${props => props.theme.palette.gray[85]};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.gray[50]};
    font-size: 24px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ margin, minHeight, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const WrapperText = styled('div')`
  padding: ${props => props.padding};
`
